import { render, staticRenderFns } from "./TabbarPaymentMethod.vue?vue&type=template&id=57842c41&scoped=true"
import script from "./TabbarPaymentMethod.vue?vue&type=script&lang=js"
export * from "./TabbarPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./TabbarPaymentMethod.vue?vue&type=style&index=0&id=57842c41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57842c41",
  null
  
)

export default component.exports